import request from '@/utils/request'

export function Login(user, pwd) {
  const data = {
    user,
    pwd,

  };
  return request({
    url: '/login_user',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    // headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
    method: 'post',
    data
  });
}
export function LoginOther(data) {
    return request({
    url: '/login_user_other',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    // headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
    method: 'post',
    data
  });
}
export function LoginToken(data) {
  return request({
  url: '/login_token_check',
  headers: {'Content-type': 'application/json;charset=UTF-8'},
  // headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
  method: 'post',
  data
});
}
